<template>
  <v-container grid-list-md>
    <v-row>
      <v-col
        v-for="listable in catalog.cataloglists"
        :key="listable.id"
        :cols="listable.cols"
      >
        {{ listable.id }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.catalog.title ? this.catalog.title : 'Loading...',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      catalog: {
         type: Object,
         required: true,
      },
   },
   methods: {
      show (_catalog) {
         this.$inertia.visit(this.route('catalog.show', _catalog))
      },
   },
}
</script>

<style>
</style>
